import { EstimateContextType } from './estimate.types';

export const estimateContextInitialValue: EstimateContextType = {
  fetchedEstimate: undefined,
  isFetchError: false,
  isFetchingEstimate: false,
  isSavingEstimate: false,
  loadEstimateCode: undefined,
  startNewEstimate: () => null,
  removeLoadEstimateCode: () => null,
  switchLoadedEstimateCode: () => null,
  resetLoadedFlags: () => null,
};
